import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map, Observable } from 'rxjs';
import { CreateOrderRequestDto } from '../models/server-models/request-dtos/create-order-request.dto';
import { CreateOrderResponseDto } from '../models/server-models/reseponse-dtos/create-order-response-dto';
import { GetPrintOrderPayStatusResponseDto } from '../models/server-models/reseponse-dtos/get-print-order-pay-status-response-dto';
import { PaymentStatus } from '../models/server-models/enums/payment-status';
import { PrintOrderDto } from '../models/server-models/entities/print-order-dto';
import { GetPrintOfficeOrdersResponseDto } from '../models/server-models/reseponse-dtos/get-print-office-orders-response-dto';
import { GetPrintOfficeOrderResponseDto } from '../models/server-models/reseponse-dtos/get-print-office-order-response-dto';
import { PrintOrderStatus } from '../models/server-models/enums/print-order-status';
import { ChangeOrderStatusRequestDto } from '../models/server-models/request-dtos/change-order-status-request-dto';
import { ChangeOrderStatusResponseDto } from '../models/server-models/reseponse-dtos/change-order-status-response-dto';
import { GetFileDownloadLinkRequestDto } from '../models/server-models/request-dtos/get-file-download-link-request-dto';
import { GetFileDownloadLinkResponseDto } from '../models/server-models/reseponse-dtos/get-file-download-link-response-dto';
import { GetUserOrdersResponseDto } from '../models/server-models/reseponse-dtos/get-user-orders-response-dto';

@Injectable({ providedIn: 'root' })
export class PrintOrderService {
  private httpClient = inject(HttpClient);

  createOrder(requestDto: CreateOrderRequestDto): Observable<CreateOrderResponseDto> {
    return this.httpClient.post<CreateOrderResponseDto>(environment.apiUrl + '/api/orders', requestDto);
  }

  getOrderPaymentStatus(orderId: string): Observable<PaymentStatus> {
    return this.httpClient
      .get<GetPrintOrderPayStatusResponseDto>(`${environment.apiUrl}/api/orders/${orderId}/payment-status`)
      .pipe(map((response) => response.paymentStatus));
  }

  getOrdersForPrintOffice(): Observable<GetPrintOfficeOrdersResponseDto> {
    return this.httpClient.get<GetPrintOfficeOrdersResponseDto>(environment.apiUrl + '/api/orders/print-office-orders');
  }

  getOrdersForUser(): Observable<PrintOrderDto[]> {
    return this.httpClient
      .get<GetUserOrdersResponseDto>(environment.apiUrl + '/api/orders/client-orders')
      .pipe(map((r) => r.orders));
  }

  getOrderForPrintOffice(orderId: string): Observable<PrintOrderDto> {
    return this.httpClient
      .get<GetPrintOfficeOrderResponseDto>(environment.apiUrl + `/api/orders/print-office-orders/${orderId}`)
      .pipe(map((r) => r.order));
  }

  getOrderForUser(orderId: string): Observable<PrintOrderDto> {
    return this.httpClient
      .get<GetPrintOfficeOrderResponseDto>(environment.apiUrl + `/api/orders/client-orders/${orderId}`)
      .pipe(map((r) => r.order));
  }

  changeStatus(orderId: string, status: PrintOrderStatus) {
    return this.httpClient.put<ChangeOrderStatusResponseDto>(`${environment.apiUrl}/api/orders/status`, <
      ChangeOrderStatusRequestDto
    >{
      orderId,
      status,
    });
  }

  getFileDownloadUrl(userId: string, uniqueFileName: string): Observable<string> {
    return this.httpClient
      .post<GetFileDownloadLinkResponseDto>(`${environment.apiUrl}/api/files/download`, <GetFileDownloadLinkRequestDto>{
        userId,
        uniqueFileName: uniqueFileName,
      })
      .pipe(map((response) => response.downloadLink));
  }

  testPaymentGoogle(token: string): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/api/payment/test-payment`, {
      token,
    });
  }
}
